import { MAIN_SIGNATORY_READ } from 'common-app/api/query/main-signatory-read';
import { MAIN_SIGNATORY_WRITE } from 'common-app/api/query/main-signatory-write';
import { MATCH_ANY_PARAMETERS } from 'wildcard-mock-link';
import { getMainSignatory, setMainSignatory } from './data';
export default [
    {
        request: {
            query: MAIN_SIGNATORY_READ,
            variables: MATCH_ANY_PARAMETERS,
        },
        result: {
            data: {
                read_main_signatory: Object.assign(Object.assign({}, getMainSignatory()), { __typename: 'SignatoryDto' }),
            },
        },
    },
    {
        request: {
            query: MAIN_SIGNATORY_WRITE,
            variables: MATCH_ANY_PARAMETERS,
        },
        result: (variables) => {
            var _a;
            let mainSignatory = getMainSignatory();
            mainSignatory = (_a = variables === null || variables === void 0 ? void 0 : variables.participant) !== null && _a !== void 0 ? _a : mainSignatory;
            setMainSignatory(mainSignatory);
            return {
                data: {
                    write_main_signatory: Object.assign(Object.assign({}, mainSignatory), { __typename: 'SignatoryDto' }),
                },
            };
        },
    },
];
